<template>
  <el-table-column
    prop="customer_postal_code"
    label="Vevő számlázási címe"
    show-overflow-tooltip
    min-width="190"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_postal_code }} {{ scope.row.customer_city }} {{ scope.row.customer_address }}
    </template>
  </el-table-column>
</template>
<script>
export default {
  propName: 'customer_postal_code',
};
</script>
